<script lang="ts">
	import { onMount } from 'svelte';
	import { format } from 'svelte-i18n';
	import { Container } from '@Shelly/shelly-design-system';
	import { getMappedRoomList, getThermostatRoomList } from '../../../Lists/list-helpers';
	import { _deepClone, capFirstChar } from 'src/helpers/utilities';
	import { rooms } from 'src/stores/lists/rooms';
	import type { ISceneObj } from 'src/types/SceneType';
	import SelectList from 'src/components/SelectList/SelectList.svelte';

	export let allRoomsRefs, selectedRef, scene_object: ISceneObj;

	$: selectedRef = allRoomsRefs[scene_object._meta.room];

	const defaultRoom = {
		id: -1,
		name: 'Global',
		icon: 'fas fa-globe',
	};

	let roomListDB = [defaultRoom];

	let selectedItem =
		scene_object?._meta.room && Number(scene_object?._meta.room) > -1
			? $rooms[scene_object?._meta.room]
			: { ...roomListDB[0] };

	$: roomListMapped = getMappedRoomList(roomListDB, scene_object._meta.room);

	const onSelectRoom = (room) => {
		selectedItem = { ...room };
		scene_object._meta.room = room.id;
	};

	onMount(() => {
		roomListDB = [...roomListDB, ...getThermostatRoomList()];
	});
</script>

<Container noScroll padding="scrollPaddings">
	<SelectList
		title={capFirstChar(
			$format('select_type', {
				values: {
					type: $format('process_room', { default: 'room' }),
				},
				default: 'Select room',
			}),
		)}
		list={roomListMapped}
		variant="radio"
		bind:allCardsRefs={allRoomsRefs}
		on:click={(e) => onSelectRoom(e.detail)}
	/>
</Container>
